/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AnyAction, AsyncThunk, AsyncThunkAction } from '@reduxjs/toolkit';
import type { AppState } from '@store/appStore.ts';
import type { InterfaceThunkDeleteData } from '@store/reducers/reducerHelpers/thunkDelete.ts';
import type { InterfaceThunkGetData } from '@store/reducers/reducerHelpers/thunkGet.ts';
import type { InterfaceThunkPostData } from '@store/reducers/reducerHelpers/thunkPost.ts';
import type { ThunkDispatch } from 'redux-thunk';

import type { DispatchActionType } from '@/types/DispatchActionType.ts';

export interface InterfaceVarReplace {
  [key: string]: string;
}

export interface InterfaceFunctionReplace {
  [key: string]: (state: AppState) => string;
}

export const defaultTypeDebounceTimeMs = 500; // 0.5 seconds

export function replaceUrlVariable(url: string, urlVarsReplaceMap: InterfaceVarReplace): string {
  let fullUrl: string = url;
  if (urlVarsReplaceMap !== undefined && Object.keys(urlVarsReplaceMap).length > 0) {
    Object.keys(urlVarsReplaceMap).forEach((key) => {
      fullUrl = fullUrl.replace(key, urlVarsReplaceMap[key]);
    });
  }
  return fullUrl ?? '';
}

export function replaceUrlState(
  url: string,
  replaceMap: InterfaceFunctionReplace,
  getState: () => AppState | unknown,
): string {
  let fullUrl: string = url;
  if (Object.keys(replaceMap).length > 0) {
    const state = getState() as AppState;
    Object.keys(replaceMap).forEach((key) => {
      fullUrl = fullUrl.replace(key, replaceMap[key](state));
    });
  }
  return fullUrl ?? '';
}

// New utility function
export function safeDispatchActions(
  dispatch: ThunkDispatch<any, unknown, AnyAction>,
  actions: DispatchActionType[],
): void {
  actions.forEach((action) => {
    // @ts-expect-error - Dispatch will handle both types correctly at runtime
    dispatch(action);
  });
}

export type DispatchAction =
  | { payload: any; type: string }
  | AsyncThunk<any, InterfaceThunkGetData | InterfaceThunkDeleteData | InterfaceThunkPostData | undefined | any, object>
  | AsyncThunkAction<any, any, any>
  | ((...args: any[]) => any);
